const colors = {
  primaryColor: "#004C97",
  secondaryColor: "#E7EAEE",
  Neutral: {
    Neutral0: "#FFFFFF",
    Neutral50: "#F6F5F3",
    Neutral100: "#ECE9E6",
    Neutral200: "#D8D4D1",
    Neutral300: "#B0A8A2",
    Neutral400: "#897D74",
    Neutral500: "#5A534D",
    Neutral600: "#4D4745",
    Neutral700: "#3E3A39",
    Neutral800: "#312F2E",
    Neutral900: "#1E1C1B"
  },
  Red: {
    Red50: "#fff2f0",
    Red100: "#ffdcd6",
    Red200: "#ffb6ad",
    Red300: "#ff8d85",
    Red400: "#ff615c",
    Red500: "#ff3232",
    Red600: "#d92127",
    Red700: "#b3121d",
    Red800: "#8c0714",
    Red900: "#660411"
  },
  Orange: {
    Orange50: "#fff8f0",
    Orange100: "#ffe3c7",
    Orange200: "#ffcb9e",
    Orange300: "#ffb175",
    Orange400: "#ff944d",
    Orange500: "#ff7223",
    Orange600: "#d95514",
    Orange700: "#b33b07",
    Orange800: "#8c2500",
    Orange900: "#661800"
  },
  Yellow: {
    Yellow50: "#fffcf0",
    Yellow100: "#fff7d9",
    Yellow200: "#ffebb0",
    Yellow300: "#ffdd87",
    Yellow400: "#ffcc5e",
    Yellow500: "#ffb835",
    Yellow600: "#d99323",
    Yellow700: "#b37014",
    Yellow800: "#8c5108",
    Yellow900: "#663705"
  },
  Green: {
    Green50: "#ebfaf3",
    Green100: "#bbedd8",
    Green200: "#8de0bf",
    Green300: "#63d4ab",
    Green400: "#3ec799",
    Green500: "#1cb989",
    Green600: "#0f9470",
    Green700: "#056e55",
    Green800: "#004739",
    Green900: "#00211c"
  },
  Cyan: {
    Cyan50: "#e6fffe",
    Cyan100: "#a2f5f5",
    Cyan200: "#74e4e8",
    Cyan300: "#4bd2db",
    Cyan400: "#25becf",
    Cyan500: "#04a7c1",
    Cyan600: "#00829c",
    Cyan700: "#005e75",
    Cyan800: "#003d4f",
    Cyan900: "#001e29"
  },
  Blue: {
    Blue50: "#DBEDFF",
    Blue100: "#B8DBFF",
    Blue200: "#70B8FF",
    Blue300: "#2994FF",
    Blue400: "#0070E0",
    Blue500: "#004C97",
    Blue600: "#003D7A",
    Blue700: "#002E5C",
    Blue800: "#001F3D",
    Blue900: "#000F1F"
  },
  Purple: {
    Purple50: "#f9f0ff",
    Purple100: "#efdbff",
    Purple200: "#d3adf7",
    Purple300: "#b37feb",
    Purple400: "#9254de",
    Purple500: "#722ed1",
    Purple600: "#531dab",
    Purple700: "#391085",
    Purple800: "#22075e",
    Purple900: "#120338"
  },
  Pink: {
    Pink50: "#fff0f6",
    Pink100: "#ffd6e7",
    Pink200: "#ffadd2",
    Pink300: "#ff85c0",
    Pink400: "#f759ab",
    Pink500: "#eb2f96",
    Pink600: "#c41d7f",
    Pink700: "#9e1068",
    Pink800: "#780650",
    Pink900: "#520339"
  },
  Shadow: {
    Shadow0: "#1A18171A",
    Shadow10: "#1A18170D"
  }
};

export default colors;
